// src/data/serumsImg/youthImages.js

export const youthImages = {
  imgBanner: require("../../img/jetCare-serums/Banner-2.png"),
  imgModal: require("../../img/jetCare-serums/Youth_Set.png"),
  productsImages: {
    "dead-sea-hydro": {
      image: require("../../img/jetCare-serums/Dead Sea Hydro.png"),
      imageBig: require("../../img/jetCare-serums/Dead _Sea_Hydro.png")
    },
    "dead-sea-exfoliation": {
      image: require("../../img/jetCare-serums/Dead Sea Exfoliation.png"),
      imageBig: require("../../img/jetCare-serums/Exfoliation.png")
    },
    "dead-sea-nourishment": {
      image: require("../../img/jetCare-serums/Dead Sea Nourishment.png"),
      imageBig: require("../../img/jetCare-serums/Dead _Sea _Nourishment.png")
    }
  }
};
